/* eslint-disable */

import { YANDEX_METRIKA_ID } from 'src/app/config'

export default {
  install() {
    if (!import.meta.env.PROD || !YANDEX_METRIKA_ID) {
      return
    }

    // @ts-expect-error
    ;(function (m: any, e: any, t: any, r: any, i: any, k: any, a: any) {
      m[i] =
        m[i] ||
        function () {
          ;(m[i].a = m[i].a || []).push(arguments)
        }

      m[i].l = new Date().getTime()

      for (let j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return
        }
      }

      k = e.createElement(t)
      a = e.getElementsByTagName(t)[0]
      k.async = 1
      k.src = r
      a.parentNode.insertBefore(k, a)
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

    window.ym?.(YANDEX_METRIKA_ID, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: false,
    })

    // app.config.globalProperties.$ym = window.ym
  },
}
